<template>
    <div>
        <p v-html="$t('all-notice-blur')"></p>
        <Filters></Filters>
        <NoticeListing :notices="notices"
                       :keys="['notice_id','notice_type','address','approval_type','ward', 'meeting_date', 'appeal_date'] "
                       :dates="['meeting_date', 'appeal_date']"
											 :default_column="sort.column"
											 :default_direction="sort.direction"
                       v-on:sort_click="sort_click"
                       :loading="loading"></NoticeListing>
        <nav :aria-label="$t('page-navigation')" v-if="total_pages > 0">
            <ul class="pagination mt-4">
                <li v-if="current_page === 1" class="page-item disabled"><a tabindex="-1" aria-disabled="true" class="page-link"><i aria-hidden="true" class="far fa-angle-left"></i><span class="sr-only">&nbsp;&nbsp;{{ $t('previous') }}</span></a></li>
                <li v-else class="page-item"><a @click="set_page(current_page - 1)" class="page-link"><i aria-hidden="true" class="far fa-angle-left"></i><span class="sr-only">&nbsp;&nbsp;{{ $t('previous') }}</span></a></li>

                <li v-for="(page_num,index) in pages_array" :key="index" class="page-item" :class="{'active': page_num && page_num === current_page}">
                    <a v-if="page_num" class="page-link" @click="set_page(page_num)">{{ page_num }}</a>
                    <span v-else class="page-indicator">...</span>
                </li>

                <li v-if="current_page === total_pages" class="page-item disabled"><a tabindex="-1" aria-disabled="true" class="page-link"><span class="sr-only">{{ $t('next') }}&nbsp;&nbsp;</span><i aria-hidden="true" class="far fa-angle-right"></i></a></li>
                <li v-else class="page-item"><a @click="set_page(current_page + 1)" class="page-link"><span class="sr-only">{{ $t('next') }}&nbsp;&nbsp;</span><i aria-hidden="true" class="far fa-angle-right"></i></a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
	import OpenData from '@/libraries/OpenData'

	import NoticeListing from '@/components/NoticeListing'
	import Filters from '@/components/Filters'

	import { mapGetters, mapMutations } from 'vuex'

	export default {
		components: { NoticeListing, Filters },

		created() {
			this.fetch_number_records();
			this.fetch();
		},

		data() {
			return {
				notices: [],
				number_of_records: null,
				loading: false,
			}
		},

		watch: {
			count_pages_parameters() {
				this.fetch_number_records();
			},
			parameters() {
				this.fetch();
			}
		},

		computed: {

			...mapGetters([
				'filters','offset','limit','sort'
			]),

			order_parameters() {
				return [{key: this.sort.column, direction: this.sort.direction }];
			},

			parameters() {
				let where_parameters = this.filters;
				let order_parameters = this.order_parameters;
				let limit_parameters = { limit: this.limit, offset: this.offset };
				return { where_parameters, order_parameters, limit_parameters };
			},

			count_pages_parameters() {
				const where_parameters = this.filters;
				const select_parameters = ['count(*)'];
				return { where_parameters, select_parameters };
			},

			current_page() {
				return Math.floor(this.offset / this.limit) + 1;
			},

			total_pages() {
				return Math.ceil(this.number_of_records / this.limit);
			},

			pages_array() {
				var pages = [];
				if (this.total_pages < 6) {
					for (var i=0; i < this.total_pages; i++) {
						pages.push(i + 1);
					}
				} else {
					var window_start = this.current_page - 1;
					var window_end = this.current_page + 1;
					if (this.current_page < 3) {
						window_start = 2;
						window_end = 3;
					} else if (this.current_page > this.total_pages - 3) {
						window_start = this.total_pages - 3;
						window_end = this.total_pages - 1;
					}
					let middle = [];
					for (var i = window_start; i <= window_end ; i++) {
						middle.push(i);
					}
					//[null is used to bring up the ... in the pagination]
					const start = (middle[0] === 2) ? [1] : [1,null];
					const end = (middle[middle.length-1] === this.total_pages - 1) ? [this.total_pages] : [null,this.total_pages];
					pages = pages.concat(start,middle,end);
				}
				return pages;
			}

		},

		methods: {
			...mapMutations([
				'set_filters','set_offset','set_limit','set_sort'
			]),

			set_page(page) {
				this.set_offset((page - 1) * this.limit);
			},

			sort_click(sort) {
				this.set_sort(sort);
				this.fetch();
			},

			async fetch() {
				const params = this.parameters;
				this.loading = true;
				const data = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
				this.notices = data;
				this.loading = false;
			},

			async fetch_number_records() {
				const params = this.count_pages_parameters;
				const data = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
				this.number_of_records = data[0].count;
			},
		},
	}
</script>

<style>
a {
	cursor: pointer;
}
</style>
